"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutSiteBase = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var Observable_1 = require("icf-search-client-shared/lib/observables/Observable");
var Profiler_1 = require("icf-search-client-shared/lib/Profiler");
var LayoutSiteBase = /** @class */ (function () {
    function LayoutSiteBase() {
        this._availableSize = new Observable_1.Observable({
            width: 0,
            height: 0,
        }, EqualityComparers_1.sizeEqualityComparer);
    }
    Object.defineProperty(LayoutSiteBase.prototype, "availableSize", {
        get: function () {
            return this._availableSize.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    LayoutSiteBase.prototype.updateAvailableSize = function (size) {
        var _this = this;
        Profiler_1.profiler.measure(function () {
            _this._availableSize.value = size;
        }, "LayoutSiteBase.updateAvailableSize");
    };
    LayoutSiteBase.prototype.dispose = function () {
        this._availableSize.dispose();
    };
    return LayoutSiteBase;
}());
exports.LayoutSiteBase = LayoutSiteBase;
//# sourceMappingURL=LayoutSiteBase.js.map